// latest: zhangmyh 2017-9-19 4:37 PM
import { URLs } from 'common'
(function () {
  let header = require('./header.html')
  document.getElementsByTagName('header')[0].innerHTML = header
  let nav = require('./nav.html')
  document.getElementsByTagName('nav')[0].innerHTML = nav
  let menu = require('./menu.html')
  document.getElementsByTagName('menu')[0].innerHTML = menu
  let footer = require('./footer.html')
  document.getElementsByTagName('footer')[0].innerHTML = footer
})()
// 用户信息
const userinform = {
  id: 0,
  name: '用户'
}

let _vm

function init () {
  _vm.searchComboData([
    { name: '采购分类', value: '01' }
    /* , { name: '销售分类', value: '02' } */
  ])
  _vm.login = function () {
    if (userinform.id !== 0) {
      let portaltype = window.localStorage.getItem('portaltype')
      window.localStorage.clear()
      if (portaltype) {
        window.localStorage.setItem('portaltype', portaltype)
      }
      window.location.href = '/yuncai/caslogout'
      return
    }
    let host = window.location.host
    if (host.indexOf('localhost') >= 0 || host.indexOf('127.0.0.1') >= 0) {
      window.location.href = '/yuncai/mobile/login.html?r=/index.html'
    } else {
      // window.location.href = '/yuncai/portal'
      window.location.href = URLs.login.url
    }
  }
  _vm.register = function () {
    if (userinform.id !== 0) {
      window.location.href = '/workbench/sso/login.jsp'
      return
    }
    window.location.href = '../register/index.zh_CN.html'
  }
  _vm.sethome = function () {
    /* eslint-disable */
    if (document.all) {
      document.body.style.behavior = 'url(#default#homepage)'
      document.body.setHomePage(window.location.href)
    } else if (window.sidebar) {
      if (window.netscape) {
        try {
          netscape.security.PrivilegeManager.enablePrivilege('UniversalXPConnect')
        } catch (e) {
          window.alert('该操作被浏览器拒绝，如果想启用该功能，请在地址栏内输入 about:config,然后将项 signed.applets.codebase_principal_support 值该为true')
        }
      }
      let prefs = Components.classes['@mozilla.org/preferences-service1'].getService(Components.interfaces.nsIPrefBranch)
      prefs.setCharPref('browser.startup.homepage', window.location.href)
    } else {
      alert('浏览器限制, 请使用浏览器菜单手动设置!')
    }
    /* eslint-enable */
  }
  _vm.addfavorite = function () {
    let url = window.location.href
    let title = document.title
    let ua = navigator.userAgent.toLowerCase()
    // IE 8
    if (ua.indexOf('msie 8') > -1) {
      window.external.AddToFavoritesBar(url, title)
    } else if (document.all) {
      try {
        window.external.addFavorite(url, title)
      } catch (e) {
        window.alert('浏览器限制,请按 Ctrl+D 手动收藏!')
      }
    } else if (window.sidebar) {
      window.sidebar.addPanel(title, url, '')
    } else {
      window.alert('浏览器限制,请按 Ctrl+D 手动收藏!')
    }
  }
  _vm.loadUser = function () {
    if (window.global.user && window.global.user.ucuserid) {
      let user = window.global.user
      userinform.id = user.id
      userinform.name = user.name
      userinform.enterprise = user.enterpriseName
      _vm.loginText('注销')
      _vm.registerText('工作台')
      _vm.welcomeText(`${userinform.enterprise}的${userinform.name}，您好，欢迎来到鞍钢集团`)
    }
  }
  let menuid = window.global.query('id')
  if (!menuid) {
    menuid = '0'
  }
  _vm.currentMenuId(menuid)
}

export default function (vm) {
  _vm = vm
  init()
}



// WEBPACK FOOTER //
// ./src/pages/common/home/header.js